import SLICE_NAMESPACE from '../types';
import NAMESPACE from './types';

function _dataSelector(state) {
    return state[SLICE_NAMESPACE][NAMESPACE];
}

function selectPartnerDetails(state) {
    return _dataSelector(state);
}

export {
    selectPartnerDetails,
};
